module.exports = __webpack_public_path__ + "assets/img/label.9d8adc09.png";